import {injectable} from 'inversify'
import {FetchOptionsFactoryProxyInterface} from '@/src/core/domain/page/functions/fetch/types'

@injectable()
export class OrderFetchOptionsFactoryProxy implements FetchOptionsFactoryProxyInterface {
  create() {
    return async (session: Nullable<Session>) => ({ignore: !session?.user?.id})
  }
}
